/* global toastr */
import React from 'react'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from './constants'
import { SigurListView } from '../lib/SigurListView'
import DocTabs from '../lib/DocTabs'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import { GrantedAccessesModalSearch } from './GrantedAccessesModalSearch'
import {AccessObjectsModalSearch} from "../access_objects/AccessObjectsModalSearch";

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      activeTab: 'people',
    }
  }

  renderModals() {
    let modals = [
      <SigurModalOrderColumn
        project_name={this.project_name}
        attrs={this.props.attrs}
        table_headers={this.props.table_headers}
        user_table_headers={this.props.user_table_headers} 
      />,
      <GrantedAccessesModalSearch
        key="search"
        project_name={this.project_name}
        schema={this.props.search_form}
        data={this.props.search_data}
        onSearch={this.onSearch}
        choices={this.props.choices}
      />
    ]


    return [...modals, ...(super.renderModals() || [])]
  }

  setTab(tab) {
    if (tab === 'autopark') {
      // Пока заглушка
      // eslint-disable-next-line no-alert
      window.alert('Раздел «Автопарк» в разработке')
      return
    }
    this.setState({ activeTab: tab })
  }

  renderContent() {
    const { activeTab } = this.state

    const docTabs = (
      <DocTabs
        tabs={['Люди', 'Автопарк']}
        selectedTab={activeTab === 'people' ? 'Люди' : 'Автопарк'}
        onSelect={(title) => {
          if (title === 'Люди') {
            this.setTab('people')
          } else {
            if (typeof toastr !== 'undefined') {
              toastr.info('Раздел «Автопарк» в разработке')
            }
          }
        }}
      />
    )
    const content = activeTab === 'people' ? super.renderContent() : null
    return [docTabs, ...(content ? (Array.isArray(content) ? content : [content]) : [])]
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
